import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { PollCard } from "@/components/HomePolls";
import { api } from "@/lib/api";
import "@/components/HomePolls.css";

export default function PollVotePage() {
  const { slug } = useParams();
  const [poll, setPoll] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/polls/by-slug/${slug}`)
      .then((r) => setPoll(r.data))
      .catch((e) => { if (e.response?.status === 404) setNotFound(true); });
  }, [slug]);

  if (notFound) {
    return (
      <>
        <Header />
        <main className="max-w-2xl mx-auto px-4 py-20 text-center">
          <h1 className="font-headline text-4xl mb-3">Encuesta no encontrada</h1>
          <Link to="/" className="text-[#ec4899]">← Volver al inicio</Link>
        </main>
        <Footer />
      </>
    );
  }
  if (!poll) return null;

  return (
    <>
      <Header />
      <main className="max-w-2xl mx-auto px-4 md:px-6 py-10" data-testid="poll-vote-page">
        <Link to="/" className="inline-flex items-center gap-1 text-sm font-bold mb-6" style={{ color: "#ec4899" }}>
          <ArrowLeft size={14} /> Volver al inicio
        </Link>
        <PollCard poll={poll} />
        {poll.status === "closed" && (
          <p className="text-center text-sm mt-6" style={{ color: "var(--text-muted)" }}>
            Esta encuesta está cerrada. <Link to={`/encuesta/${poll.slug}/resultados`} style={{ color: "#ec4899" }}>Ver resultados →</Link>
          </p>
        )}
      </main>
      <Footer />
    </>
  );
}
